import { joinClasses } from 'utils/componentStyles/style.utils';
import SevereWeatherAlertAreaSelect from '../SevereWeatherAlertAreaSelect/SevereWeatherAlertAreaSelect';
import SevereWeatherAlertDetails from './components/SevereWeatherAlertDetails/SevereWeatherAlertDetails';
import SevereWeatherAlertList from './components/SevereWeatherAlertList/SevereWeatherAlertList';

const SevereWeatherAlertPanel = ({
  areas = [],
  selectedArea,
  selectedAlert,
  selectedAlertId,
  onSelectArea,
  onSelectAlert,
}) => {
  const hasMultipleAlerts = selectedArea?.alerts?.length > 1;
  const hasSelectedAlert = Boolean(selectedArea && selectedAlert);

  return (
    <div className="severe-weather-alert-panel d-flex h-100 min-h-0 flex-column gap-2 overflow-hidden p-2">
      <SevereWeatherAlertAreaSelect
        areas={areas}
        selectedAreaId={selectedArea?.id}
        onSelectArea={onSelectArea}
      />

      {hasSelectedAlert ? (
        <div
          className={joinClasses(
            'severe-weather-alert-panel-content min-h-0 flex-grow-1',
            hasMultipleAlerts && 'has-alert-list',
          )}
        >
          <SevereWeatherAlertDetails
            alert={selectedAlert}
            area={selectedArea}
            className="min-h-0 overflow-auto"
          />

          {hasMultipleAlerts && (
            <SevereWeatherAlertList
              alerts={selectedArea.alerts}
              selectedAlertId={selectedAlertId}
              onSelectAlert={onSelectAlert}
            />
          )}
        </div>
      ) : (
        <div className="d-flex min-h-0 flex-grow-1 align-items-center justify-content-center p-3 text-center">
          Select an alert area on the map or from the list above to view its details.
        </div>
      )}
    </div>
  );
};

export default SevereWeatherAlertPanel;
